import { render, staticRenderFns } from "./cover-preview.vue?vue&type=template&id=1b3da624&scoped=true"
import script from "./cover-preview.vue?vue&type=script&lang=js"
export * from "./cover-preview.vue?vue&type=script&lang=js"
import style0 from "./cover-preview.vue?vue&type=style&index=0&id=1b3da624&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3da624",
  null
  
)

export default component.exports